import { Col, Row } from 'react-bootstrap';
import experience from '../../api/resume.json';
import React from 'react';

const Resume = () => {
  return (
    <div className="resume-page text-light p-md-5">
    
     {/* Experience List */}
     <div className="experience-list">
        {experience.map((item, index) => (
          <div
            key={index}
            className={`experience-item d-flex position-relative mb-2 row ${
              index === 0 ? "first-item" : ""
            }`}
          >
            {/* Dates Section */}
            <div className="col-3 text-end date">
              <p className="mb-0">{item.start}</p>
              <p className="mb-0">{item.end}</p>
            </div>

            {/* Vertical Bar */}
            <div className="col-1 d-md-flex justify-content-center align-items-center d-none">
              <div className={`vertical-bar ${index === 0 ? "glowing-bar" : ""}`}></div>
            </div>

            {/* Company and Title */}
            <div className="col-9 col-md-8 details ps-4">
              <h3 className="mb-0 fs-5">{item.company}</h3>
              <p className="description">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Resume;
